const ranges = [
    { min: 0, max: 0, opacity: 0 },
    { min: 1, max: 0.1 * 60000, opacity: 0.1 },
    { min: 0.1 * 60000, max: 0.3 * 60000, opacity: 0.2 },
    { min: 0.3 * 60000, max: 0.5 * 60000, opacity: 0.3 },
    { min: 0.5 * 60000, max: 0.7 * 60000, opacity: 0.4 },
    { min: 0.7 * 60000, max: 0.9 * 60000, opacity: 0.5 },
    { min: 0.9 * 60000, max: 2 * 60000, opacity: 0.6 },
    { min: 2 * 60000, max: 3 * 60000, opacity: 0.7 },
    { min: 3 * 60000, max: 5 * 60000, opacity: 0.8 },
    { min: 5 * 60000, max: 8 * 60000, opacity: 0.9 },  
    { min: 8 * 60000, opacity: 1 }     
];

  
export function mapDurationToOpacity(duration: number): number {
    for (const range of ranges) {
        if (range.min <= duration && (range.max === undefined || duration <= range.max)) {
            return range.opacity;
        }
    }
    throw new Error(`mapDurationToOpacity: Invalid duration input ${duration}`);
}
